var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{staticClass:"mt-4 mb-4 col-for-card height-700",attrs:{"cols":"12","md":"12","lg":"12"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }